module.exports = __webpack_public_path__ + "resources/img/img_prolinux8_m.ff7f31da4222e2bd501135efc368231c.png";